(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBarAppliedFilters', rmsFilterBarAppliedFilters);

    function rmsFilterBarAppliedFilters() {
        return {
            restrict: 'E',
            scope: {
                list: '=',
                identifier: '=?'
            },
            controller: rmsFilterBarAppliedFiltersCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/applied-filters'
        };
    }

    function rmsFilterBarAppliedFiltersCtrl($scope, MainFilterBarService, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = vm.identifier || $scope.$parent.vm.filterBarIdentifier;

            if (vm.identifier) {
                $timeout(function() {
                    init();
                });
            } else {
                init();
            }
        }

        function init() {
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();
            vm.state = vm.filterBarService().getState();
            vm.show_empty_state = lodash.get(vm.filterBarService().getFilterBarOptions(), 'show_empty_state', false);
            vm.empty_state_message = vm.filterBarService().getMessageLabel('empty_state');
        }
    }
})();